import {
    escapePrintViewText,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const extractHotTextTokenHtml = (hotTextElement) => {
    const selectedText = hotTextElement.getAttribute('selected_text') || ''

    return escapePrintViewText(selectedText)
}

const buildHotTextQuestionPrintView = (content) => {
    const instructionHtml = replaceMediaLikeTagsWithIds(content.instruction || '')
    const questionTemplate = document.createElement('template')
    questionTemplate.innerHTML = replaceMediaLikeTagsWithIds(content.question || '')

    const correctHotText = []
    const incorrectHotText = []

    questionTemplate.content.querySelectorAll('hot_text').forEach((hotTextElement) => {
        const tokenHtml = extractHotTextTokenHtml(hotTextElement)

        if (!tokenHtml) {
            hotTextElement.replaceWith('')
            return
        }

        if (hotTextElement.getAttribute('correct') === 'true') {
            correctHotText.push(tokenHtml)
        } else {
            incorrectHotText.push(tokenHtml)
        }

        hotTextElement.replaceWith(tokenHtml)
    })

    const questionHtml = questionTemplate.innerHTML
    const instructionSectionHtml = instructionHtml ? `<p>Instruction:</p>${instructionHtml}` : ''
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''
    const correctHotTextSectionHtml = correctHotText.length
        ? `<p>&nbsp;</p><p>Correct Hot Text:</p>${correctHotText.map((token) => `<p>${token}</p>`).join('')}`
        : ''
    const incorrectHotTextSectionHtml = incorrectHotText.length
        ? `<p>&nbsp;</p><p>Incorrect Hot Text:</p>${incorrectHotText.map((token) => `<p>${token}</p>`).join('')}`
        : ''

    return `${instructionSectionHtml}${questionSectionHtml}${correctHotTextSectionHtml}${incorrectHotTextSectionHtml}`
}

export {buildHotTextQuestionPrintView}
